<template>
    <div role="form">
        <div class="form-group">
            <label class="form-label" for="name">Your name</label>
            <input type="text" v-model="name" size="40" class="form-control my-1" aria-required="true" aria-invalid="false" required>
        </div>

        <div class="form-group">
            <label class="form-label" for="email">Your email</label>
            <input type="email" v-model="email" size="40" class="form-control my-1 mr-md-0" aria-required="true" aria-invalid="false" required>
        </div>

        <div class="form-group">
            <label class="form-label" for="content">Your enquiry</label>
            <textarea v-model="content" cols="40" rows="20" style="height: 150px;" class="form-control" aria-required="true" aria-invalid="false" required></textarea>
        </div>
        <div class="mt-4">
            <button class="btn btn-primary" @click="handleForm" :disabled="isBusy">Submit</button>
        </div>
        <div class="alert alert-danger" v-show="showError">{{ error }}</div>
        <div class="alert alert-success" v-show="showSuccess">Thank you for your message, we will be in touch soon.</div>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'contact'
            },
        },

        data() {
            return {
                showSuccess: false,
                error: '',
                showError: false,
                isBusy: false,
            }
        },

        mounted() {

        },

        methods: {
            /**
             * Handle form submission
             */
            handleForm() {
                this.isBusy = true;

                axios.post('/api/contact-form', {
                        name: this.name,
                        email: this.email,
                        content: this.content,
                        type: this.type
                    }).then((response) => {
                        // The form was pushed
                        if(response.data.error) {
                            this.error = response.data.error;
                            this.showError = true;
                            this.isBusy = false;
                        } else {
                            this.showError = false;
                            this.showSuccess = true;
                        }
                    });
            }
        }
    }
</script>
